import { render, staticRenderFns } from "./challenges-modal.vue?vue&type=template&id=097121ed&"
import script from "./challenges-modal.vue?vue&type=script&lang=js&"
export * from "./challenges-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports